module.exports = __webpack_public_path__ + "assets/img/solut2_8.5454d04c.png";